import { render, staticRenderFns } from "./EvidencesList.vue?vue&type=template&id=1f30080c&"
import script from "./EvidencesList.vue?vue&type=script&lang=ts&"
export * from "./EvidencesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports